/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Smb_Root_Path_HintInputs */



/**
* | output |
* | --- |
* | "Subdirectory within the share to sync. Leave as / to sync the whole share." |
*
* @param {Spaces_Smb_Root_Path_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_smb_root_path_hint = /** @type {((inputs?: Spaces_Smb_Root_Path_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Smb_Root_Path_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Unterverzeichnis innerhalb der Freigabe, das synchronisiert werden soll. Lassen Sie es auf /, um die gesamte Freigabe zu synchronisieren.")
	return /** @type {LocalizedString} */ ("Subdirectory within the share to sync. Leave as / to sync the whole share.")
});